import { toast } from "react-toastify";
import {
  addMealCategoryService,
  deleteMealCategoryService,
  getCategoryByIdService,
  getMealCategoryListService,
} from "../../../Services/MealCategory";
import {
  addCategoryFailure,
  addCategoryStart,
  addCategorySuccess,
  deleteCategoryFailure,
  deleteCategoryStart,
  deleteCategorySuccess,
  editCategoryFailure,
  editCategoryStart,
  editCategorySuccess,
  fetchCategoriesFailure,
  fetchCategoriesStart,
  fetchCategoriesSuccess,
  getCategoryByIdFailure,
  getCategoryByIdStart,
  getCategoryByIdSuccess,
} from "./reducer";

//thunk for fetch the category list
export const fetchMealCategoryList =
  (params = {}) =>
  async (dispatch) => {
    try {
      dispatch(fetchCategoriesStart());
      const response = await getMealCategoryListService(params);

      if (params.isPagination === 0) {
        // const currentPagination = getState().MealCategory.pagination;
        dispatch(
          fetchCategoriesSuccess({
            categories: response.data, // full list
            // pagination: currentPagination,
            pagination: {
              totalPages: 1,
              totalElements: response.data.length,
              currentPage: 0,
              pageSize: response.data.length,
              isLastPage: true,
              isFirstPage: true,
            },
          })
        );
      } else if (response?.data?.content) {
        dispatch(
          fetchCategoriesSuccess({
            categories: response.data.content,
            pagination: {
              totalPages: response.data.totalPages,
              totalElements: response.data.totalElements,
              currentPage: response.data.pageable.pageNumber,
              pageSize: response.data.pageable.pageSize,
              isLastPage: response.data.last,
              isFirstPage: response.data.first,
            },
          })
        );
      } else {
        dispatch(fetchCategoriesFailure("No data found"));
      }
    } catch (error) {
      dispatch(fetchCategoriesFailure(error));
    }
  };

//thunk for the addig the category

export const addMealCategory = (formData) => async (dispatch) => {
  try {
    dispatch(addCategoryStart());

    const name = formData.get("name");

    const imageFormData = new FormData();
    imageFormData.append("images", formData.get("image"));

    const requestParam = { name: name };

    const response = await addMealCategoryService(imageFormData, requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(addCategorySuccess(response));
    } else {
      toast.error("Something went wrong ");
      dispatch(addCategoryFailure("Failed to add category"));
    }
  } catch (error) {
    toast.error(error);

    dispatch(addCategoryFailure(error));
  }
};

//this is the thunk for delete the category
export const deleteMealCategory = (categoryId) => async (dispatch) => {
  try {
    dispatch(deleteCategoryStart());

    const response = await deleteMealCategoryService(categoryId);

    if (response?.success) {
      toast.success(response.message);
      dispatch(deleteCategorySuccess(categoryId));
    } else {
      toast.error("Failed to delete category");
      dispatch(deleteCategoryFailure("Delete failed"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(deleteCategoryFailure(error));
  }
};

//this tunk for the edit meal category
export const editMealCategory = (formData) => async (dispatch) => {
  try {
    dispatch(editCategoryStart());

    let response;
    const name = formData.get("name");
    const id = formData.get("id");
    const image = formData.get("image");
    const requestParam = { id, name };

    const imageFormData = new FormData();
    // if (formData.get("image")) {
    //   imageFormData.append("images", formData.get("image"));
    // }

    if (image instanceof File && image.size > 0) {
      // const imageFormData = new FormData();

      imageFormData.append("images", image);
    }
    response = await addMealCategoryService(imageFormData, requestParam);

    if (response?.success) {
      toast.success(response.message);
      dispatch(editCategorySuccess(response));
    } else {
      dispatch(editCategoryFailure("Failed to update category"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(editCategoryFailure(error));
  }
};

//this thunk is for the get by id
export const fetchMealCategoryById = (id) => async (dispatch) => {
  try {
    dispatch(getCategoryByIdStart());
    const response = await getCategoryByIdService(id);
    if (response?.data) {
      dispatch(getCategoryByIdSuccess(response.data));
    } else {
      dispatch(getCategoryByIdFailure("No category found"));
    }
  } catch (error) {
    toast.error(error);
    dispatch(getCategoryByIdFailure(error));
  }
};
